var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current-market-wrapper",class:{ 'current-market-wrapper--selected': _vm.storeSelected }},[(_vm.storeInfo)?_c('MarketInfoBox'):_c('SelectMarketButton',{attrs:{"bem-modifiers":"pick-shop"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }